import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { FormattedMessage } from 'react-intl';

import useElementSize from '../../hooks/useElementSize';
import * as AppPropTypes from '../../lib/PropTypes';

import { useUrlFromHandle } from '../../contexts/RoutesContext';
import PrizeCard from '../cards/Prize';
import ListHeader from '../partials/ListHeader';

import styles from '../../../styles/blocks/awards.module.scss';

const propTypes = {
    title: PropTypes.node,
    description: PropTypes.node,
    awards: AppPropTypes.listItems,
    edition: AppPropTypes.edition,
    url: PropTypes.string,
    fullSize: PropTypes.bool,
    isGrid: PropTypes.bool,
    isContainer: PropTypes.bool,
    isDark: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    title: null,
    description: null,
    awards: null,
    edition: null,
    url: null,
    fullSize: false,
    isGrid: true,
    isContainer: true,
    isDark: false,
    className: null,
};

const AwardsBlock = ({
    title,
    description,
    awards,
    edition,
    url,
    fullSize,
    isGrid,
    isContainer,
    isDark,
    className,
}) => {
    const ref = useRef(null);
    const { current } = ref || null;
    const { width: gridWidth = null } = useElementSize(current);

    let columns = null;
    if (gridWidth !== null) {
        if (gridWidth < 850) {
            columns = 1;
        } else if (gridWidth > 850 && gridWidth < 1600) {
            columns = 2;
        } else if (gridWidth > 1600) {
            columns = 3;
        }
    }

    const handle = useUrlFromHandle();
    // const route = useUrlGenerator();
    const hasTitle = title !== null;
    const { id: editionId } = edition || {};

    return (
        <div
            ref={ref}
            className={classNames([
                styles.container,
                {
                    [styles.grid]: isGrid && !fullSize,
                    [styles.fullSize]: fullSize,
                    [styles.isContainer]: isContainer,
                    [styles.hasTitle]: hasTitle !== null,
                    [className]: className !== null,
                },
            ])}
        >
            <ListHeader
                className={styles.header}
                title={hasTitle ? title : null}
                description={description}
                link={
                    editionId !== null
                        ? {
                              href: handle('prizes-jury', { edition: editionId }),
                              label: (
                                  <FormattedMessage
                                      defaultMessage="View all award winners"
                                      description="Button label"
                                  />
                              ),
                          }
                        : url
                }
                isDark={isDark}
            />
            <div className={classNames([styles.inner, styles[`columns${columns}`]])}>
                {(awards || []).map((award) => {
                    const { prizes = null } = award || null;
                    return (prizes || []).map((prize, index) => (
                        <PrizeCard
                            key={`prize-card${index + 1}`}
                            item={prize}
                            award={award}
                            vertical={isGrid && !fullSize}
                            className={styles.prize}
                        />
                    ));
                })}
            </div>
        </div>
    );
};
AwardsBlock.propTypes = propTypes;
AwardsBlock.defaultProps = defaultProps;

export default AwardsBlock;
